import { ListItemIcon, ListItemText, MenuItem, Stack } from "@mui/material";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { FeatureName } from "@/common/constants/featureName";
import { ROUTE_PATH } from "@/common/constants/routing";
import { featureManager } from "@/config/features";
import { AppPermission, WheelOperationDto } from "@/core/api/generated/v1";

import AuthorizedElement from "../../Auth/AuthorizedElement";
import EntityMenu from "../../EntityMenu/EntityMenu";
import AppIcon from "../../Icons/AppIcon";
import WheelOperationAddToAssignmentModal from "./WheelOperationAddToAssignmentModal";
import WheelOperationDeleteModal from "./WheelOperationDeleteModal";

enum ActionFlags {
  Edit = "Edit",
  Delete = "Delete",
  AddToAssignment = "AddToAssignment",
}
const defaultDisplayProps = {
  actions: {
    edit: true,
    delete: true,
    addToAssignment: true,
  },
};

interface TriggersProps {
  entity?: WheelOperationDto | null;
  definition: typeof ActionFlags;
  handleClose: () => void;
  startAction: (props: ActionFlags) => void;
}

interface Props {
  entity: WheelOperationDto | null;
  disabled?: boolean;
  onUpdate: ((newValue: WheelOperationDto | null | undefined) => void) | undefined;
  onDelete?: (() => void) | undefined;
  displayProps?: Partial<typeof defaultDisplayProps>;
  customActions?: (props: TriggersProps) => ReactNode;
}

export default function WheelOperationMenu({
  entity,
  disabled,
  customActions,
  onUpdate,
  onDelete,
  displayProps = defaultDisplayProps,
}: Props) {
  displayProps = { ...defaultDisplayProps, ...displayProps };
  return (
    <EntityMenu
      definition={ActionFlags}
      entity={entity}
      disabled={disabled}
      actionTriggers={({ handleClose, startAction }) => (
        <>
          {customActions &&
            customActions({
              entity,
              definition: ActionFlags,
              handleClose,
              startAction,
            })}
          {displayProps?.actions?.edit && (
            <MenuItem component={RouterLink} to={ROUTE_PATH.WHEEL_OPERATION_EDIT(entity?.id)}>
              <ListItemIcon>
                <AppIcon of='edit' fontSize='small' />
              </ListItemIcon>
              <ListItemText>Edit</ListItemText>
            </MenuItem>
          )}
          {displayProps?.actions?.delete && (
            //<AuthorizedElement permissions={[AppPermission.WheelOperationManage]}>
            <MenuItem onClick={() => startAction(ActionFlags.Delete)}>
              <ListItemIcon>
                <AppIcon of='delete' fontSize='small' />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
            //</AuthorizedElement>
          )}
          {/* Add ot assignment */}
          {/* temporary hide on prod */}
          {featureManager.isEnabled(FeatureName.Assignments) &&
            displayProps?.actions?.addToAssignment && (
              <AuthorizedElement permissions={[AppPermission.WheelOperationManage]}>
                <MenuItem
                  disabled={!!entity?.assignment}
                  onClick={() => startAction(ActionFlags.AddToAssignment)}
                >
                  <ListItemIcon>
                    <AppIcon of='add' fontSize='small' />
                  </ListItemIcon>
                  <ListItemText>Add to assignment</ListItemText>
                </MenuItem>
              </AuthorizedElement>
            )}
        </>
      )}
      actionHandlers={({ currentAction, cancelAction, completeAction }) => (
        <Stack>
          {/* Delete */}
          {entity && (
            <WheelOperationDeleteModal
              entity={entity}
              open={currentAction === ActionFlags.Delete}
              onClose={() => cancelAction()}
              onDelete={() => {
                onDelete && onDelete();
                completeAction();
              }}
            />
          )}

          {/* Add to assignment */}
          {entity && (
            <WheelOperationAddToAssignmentModal
              open={currentAction === ActionFlags.AddToAssignment}
              onClose={() => cancelAction()}
              wheelOperation={entity}
              onSaved={() => {
                onUpdate && onUpdate(null);
                completeAction();
              }}
            />
          )}
        </Stack>
      )}
    />
  );
}
